export default __webpack_public_path__ + "static/media/080_finish_soso.last.ee664802.webp";